import { render, staticRenderFns } from "./PluginTableItemsSkeleton.vue?vue&type=template&id=03f100c0&scoped=true"
import script from "./PluginTableItemsSkeleton.vue?vue&type=script&lang=js"
export * from "./PluginTableItemsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PluginTableItemsSkeleton.vue?vue&type=style&index=0&id=03f100c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f100c0",
  null
  
)

export default component.exports